//@ts-nocheck

const provisionsAccordion = () => {
  const provisions = document.querySelectorAll(".js-provision");
  if (provisions.length == 0) {
    return;
  }

  const buttons = document.querySelectorAll(".js-provision-btn");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      button.parentNode?.classList.toggle("active");
    });
  });

  const setHeight = () => {
    provisions.forEach((item) => {
      let height = item.querySelector(".js-provision-title");
      let marginHeight = parseFloat(getComputedStyle(height).marginBottom);
      height = height?.getBoundingClientRect().height;
      item.style.maxHeight = height + marginHeight + 2 + "px";
    });
  };
  setHeight();
  window.addEventListener("resize", setHeight);
};

export default provisionsAccordion;
